import {FieldLabel} from '../label/fileld-label';
import {AsyncCustomValidatorFn, CustomValidatorFn} from '../validation/custom-validatror';
import {FieldTypeEnum} from './field-type.enum';
import {FieldAffix} from '../affix/field-affix';
import {FieldHint} from '../hint-text/field-hint';

export class FieldConfig<T> {
    id?: string;
    name: string;
    type: FieldTypeEnum;
    /** Css class */
    class?: string;
    readonly?: boolean;
    disabled?: boolean;
    required?: boolean;
    hidden?: boolean;
    hint?: FieldHint;
    label?: FieldLabel;
    prefix?: FieldAffix;
    suffix?: FieldAffix;
    tooltip?: { text: string };
    validators?: Array<CustomValidatorFn> | CustomValidatorFn;
    asyncValidators?: Array<AsyncCustomValidatorFn> | AsyncCustomValidatorFn;
    value?: T | Promise<T>;
}
